import { NavLink } from "react-router-dom";
import { BsLayoutSidebar, BsLayoutSidebarReverse } from "react-icons/bs";
import { LuUsers } from "react-icons/lu";
import { RiTeamLine } from "react-icons/ri";
import { TbMailCog, TbSettings } from "react-icons/tb";
import { PiUserSwitch } from "react-icons/pi";
import { MdOutlineDashboard, MdNotifications } from "react-icons/md";

export default function Sidebar({ collapsed, setCollapsed, switchToSelf }) {

  function getActive(path) {
    const currentPath = window.location.hash.replace(/^#/, "");
    return currentPath === path;
  }

  const topMenu = [
    { name: "Overview", path: "/assessment/overview", isActive: getActive("/assessment/overview"), icon: <MdOutlineDashboard className="w-5 h-5" /> },
    { name: "My Users", path: "/assessment/myusers", isActive: getActive("/assessment/myusers"), icon: <LuUsers className="w-5 h-5" /> },
    { name: "My Teams", path: "/assessment/myteams", isActive: getActive("/assessment/myteams"), icon: <RiTeamLine className="w-5 h-5" /> },
    { name: "My Results", path: "/assessment/myresults", isActive: getActive("/assessment/myresults"), icon: <RiTeamLine className="w-5 h-5" /> },

    // { name: "My Campaigns", path: "/assessment/mycampaigns", isActive: getActive("/assessment/mycampaigns"), icon: <TbMailCog className="w-5 h-5" /> },
    { name: "Settings", path: "/assessment/settings", isActive: getActive("/assessment/settings"), icon: <TbSettings className="w-5 h-5" /> },
  ];

  return (

    <aside className={`fixed top-0 left-0 h-screen bg-[#f9fafb] border-r transition-all duration-300 z-40  ${collapsed ? "w-20" : "w-64"} flex flex-col`}>
      {/* Header */}
      <div className="flex items-center justify-between px-4 py-5">
        {!collapsed && (
          <div className="text-2xl font-bold tracking-tight">
            <img src="/img/TalentPlusStrengths_logo.svg" alt="TalentPlusStrengths_logo" className="bg-cover cursor-pointer md:w-36 w-28"></img>
          </div>
        )}

        <button onClick={() => setCollapsed(!collapsed)} className="p-2 rounded-lg hover:bg-gray-100">
          {collapsed ? (
            <BsLayoutSidebar className="w-5 h-5" />
          ) : (
            <BsLayoutSidebarReverse className="w-5 h-5" />
          )}
        </button>
      </div>

      {/* Top Menu */}
      <nav className="mt-4 space-y-1 px-2">
        {topMenu.map((item) => (
          <NavLink
            key={item.name}
            to={item.path}
            end
            className={({ }) =>
              `group flex items-center gap-3 px-4 py-3 rounded-lg text-base font-medium transition 
              ${item.isActive
                ? "bg-gradient-to-r from-[#673AB7] to-[#1976D2] text-white"
                : "hover:bg-gray-200 hover:text-black"
              }`
            }
          >
            <span>{item.icon}</span>
            <span className={`transition-all duration-600 ease-in-out overflow-hidden ${collapsed ? "opacity-0 max-w-0" : "opacity-100 max-w-xs ml-2"}`}>{item.name}</span>
            {/* Tooltip */}
            {collapsed && (
              <span className="absolute left-16 bg-black text-white text-xs px-2 py-1 rounded  opacity-0 group-hover:opacity-100 whitespace-nowrap">{item.name}</span>
            )}
          </NavLink>
        ))}
      </nav>

      {/* Bottom Section (Fixed) */}
      <div className="mt-auto px-2 pb-4">
        <div className="border-t my-4" />

        {/* Notification */}
        {/* <NavLink to="/assessment/notifications" className="group flex items-center gap-3 px-4 py-3 rounded-lg text-sm text-gray-700 hover:bg-gray-100 relative">
          <MdNotifications className="w-5 h-5" />
          {!collapsed && <span>Notification</span>}
          {collapsed && (
            <span className="absolute left-16 bg-black text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 whitespace-nowrap">Notification</span>
          )}
        </NavLink> */}

        {/* Account */}
        {/* <NavLink to="/assessment/myaccount" className="group flex items-center gap-3 px-4 py-3 rounded-lg text-sm text-gray-700 hover:bg-gray-100 relative">
          <LuUsers className="w-5 h-5" />
          {!collapsed && <span>Account</span>}
          {collapsed && (
            <span className="absolute left-16 bg-black text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 whitespace-nowrap">Account</span>
          )}
        </NavLink>

        <div onClick={() => switchToSelf()} className="cursor-pointer group flex items-center gap-3 px-4 py-3 mt-2 rounded-lg text-sm bg-gray-200 hover:bg-gray-300 font-medium relative">
          <PiUserSwitch className="w-5 h-5" />
          {!collapsed && <span>Switch to Self</span>}
          {collapsed && (
            <span className="absolute left-16 bg-black text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 whitespace-nowrap">Switch to Self</span>
          )}
        </div> */}
      </div>

    </aside>
  );
}
